<template>
  <div
    v-if="numberOfPages > 1"
    class="text-center vertical-offset4"
  >
    <ul class="pagination">
      <li>
        <a
          :class="isFirstPage ? 'disabled' : 'cursor-pointer'"
          @click="goBackOne"
        >&lt;</a>
      </li>
      <li
        v-for="page in pageLinks"
        :key="page.value"
        :class="currentPage === (page.value) ? 'active' : ''"
      >
        <a
          class="cursor-pointer"
          @click="onCurrentPageChange.call(undefined, page.value)"
        >{{ page.label }}</a>
      </li>
      <li>
        <a
          :class="isLastPage ? 'disabled' : 'cursor-pointer'"
          @click="goFowardOne"
        >&gt;</a>
      </li>
    </ul>
  </div>
</template>

<script>
import createPaginationPageLinks from '../services/createPaginationPageLinks';

export default {
  name: 'TrNumericalPagination',
  props: {
    currentPage: {
      required: false,
      type: Number,
      default: 0
    },
    pageSize: {
      required: false,
      type: Number,
      default: 50
    },
    maxPagesShown: {
      required: false,
      type: Number,
      default: 7
    },
    total: {
      required: false,
      type: Number,
      total: 0
    },
    onCurrentPageChange: {
      required: true,
      type: Function
    }
  },
  computed: {
    pageLinks() {
      return createPaginationPageLinks.create(
        this.maxPagesShown,
        this.currentPage,
        this.numberOfPages
      );
    },
    isFirstPage() {
      return Boolean(this.currentPage === 0);
    },
    isLastPage() {
      return Boolean(this.currentPage + 1 === this.numberOfPages);
    },
    numberOfPages() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  methods: {
    goBackOne() {
      if (!this.isFirstPage) {
        this.onCurrentPageChange(this.currentPage - 1);
      }
    },
    goFowardOne() {
      if (!this.isLastPage) {
        this.onCurrentPageChange(this.currentPage + 1);
      }
    }
  }
};
</script>
